import { render } from "./P067.vue?vue&type=template&id=19c1c86c&scoped=true"
import script from "./P067.vue?vue&type=script&lang=js"
export * from "./P067.vue?vue&type=script&lang=js"

import "./P067.vue?vue&type=style&index=0&id=19c1c86c&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c1c86c"]])

export default __exports__